var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('img',{staticClass:"errorPic",attrs:{"src":"/static/images/maintain.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"text-cent"},[_c('p',{staticClass:"text-left col-999"},[_vm._v(_vm._s(_vm.datas))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-459f7da7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/activity/maintain.vue
// module id = null
// module chunks = 